import { Component, Input, OnInit } from '@angular/core';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-rest-api-data-connector',
    templateUrl: './rest-api-data-connector.component.html',
    styleUrls: ['./rest-api-data-connector.component.css'],
    standalone: false
})
export class RestApiDataConnectorComponent implements OnInit {

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;

  httpMethods = ['GET', 'POST', 'PUT', 'DELETE'];

  viewModel = {
    httpMethod: 'GET',
    endpointUrl: '',
    authType: 'none',   // "none" | "basic" | "bearer" | "apikey"
    userName: '',
    password: '',
    bearerToken: '',
    apiKey: '',
    apiKeyLocation: 'header' // 'header' or 'query'
  };

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  sendRequest(): void {
    console.log('Sending request:', this.viewModel);

    let headers = new HttpHeaders();
    let url = this.viewModel.endpointUrl;

    // Handle authentication
    if (this.viewModel.authType === 'basic') {
      const token = btoa(`${this.viewModel.userName}:${this.viewModel.password}`);
      headers = headers.set('Authorization', `Basic ${token}`);
    } else if (this.viewModel.authType === 'bearer') {
      headers = headers.set('Authorization', `Bearer ${this.viewModel.bearerToken}`);
    } else if (this.viewModel.authType === 'apikey') {
      if (this.viewModel.apiKeyLocation === 'header') {
        headers = headers.set('x-api-key', this.viewModel.apiKey);
      } else if (this.viewModel.apiKeyLocation === 'query') {
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}api_key=${this.viewModel.apiKey}`;
      }
    }

    // Send the HTTP request
    this.http.request(this.viewModel.httpMethod, url, { headers })
      .subscribe({
        next: (res) => console.log('Response:', res),
        error: (err) => console.error('Error:', err)
      });
  }
}
